import { useState } from 'react';
import { Box, Paper, IconButton, useTheme } from '@mui/material';
import { Typography } from '../../primitives/typography/typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

export const CodeBlock = ({ code = '', language = 'text', title = '' }) => {
  const [copied, setCopied] = useState(false);
  const theme = useTheme();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minWidth: 0,
        overflow: 'hidden',
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 1.5,
          py: 0.5,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'action.hover',
        }}
      >
        <Typography.BodyEmphasised sx={{ fontFamily: 'monospace' }}>
          {title || language}
        </Typography.BodyEmphasised>
        <IconButton onClick={handleCopy} size="small" sx={{ p: 0.5 }}>
          {copied ? (
            <CheckIcon fontSize="inherit" color="success" />
          ) : (
            <ContentCopyIcon fontSize="inherit" />
          )}
        </IconButton>
      </Box>

      <Box
        component="pre"
        sx={{
          p: 1.5,
          m: 0,
          overflowX: 'auto',
          fontFamily: 'monospace',
          fontSize: '0.75rem',
          lineHeight: 1.5,
          textAlign: 'left',
          bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'grey.50',
          color: 'text.primary',
          maxWidth: '100%',
          '& code': {
            whiteSpace: 'pre',
            display: 'block',
          },
        }}
      >
        <code>{code}</code>
      </Box>
    </Paper>
  );
};
